import { format, parseISO } from "date-fns";

// `yyyy-MM-dd` is the wire format for date parameter values: it is what the
// publication path emits via `date_value.isoformat()` and what the semantic
// layer forwards into the Cube `dateRange`. `parseISO` reads a date-only string
// as local midnight, avoiding the `new Date("yyyy-MM-dd")` UTC off-by-one in
// negative-UTC zones.

export const parseIsoDate = (value: string | null): Date | null => {
  if (!value) {
    return null;
  }
  const parsed = parseISO(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatIsoDate = (value: Date | null): string | null =>
  value ? format(value, "yyyy-MM-dd") : null;
